export const STATUS_CONFRONTO = [
    { value: "ENCONTRADO", label: "Encontrado", badge: "bg-emerald-100 text-emerald-800" },
    { value: "NAO_ENCONTRADO", label: "Não encontrado no SAP", badge: "bg-red-100 text-red-800" },
    { value: "DIVERGENCIA_VALOR", label: "Divergência de valor", badge: "bg-amber-100 text-amber-800" },
    { value: "CANCELADO_NO_FORTES", label: "Cancelado no Fortes", badge: "bg-slate-200 text-slate-700" },
    { value: "AMBIGUO", label: "Ambíguo", badge: "bg-purple-100 text-purple-800" },
    { value: "SUBSTITUIDO", label: "Substituído", badge: "bg-blue-100 text-blue-800" },
    { value: "IGNORADO_MANUALMENTE", label: "Ignorado (manual)", badge: "bg-slate-200 text-slate-700" },
];

export const STATUS_MANUAL_CTE = [
    { value: "SUBSTITUIDO", label: "Substituído por novo CTE" },
    { value: "IGNORADO", label: "Ignorar (outro motivo)" },
];

export function statusInfo(status) {
    return STATUS_CONFRONTO.find(s => s.value === status) || { label: status, badge: "bg-muted text-muted-foreground" };
}
